/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_ResumesInputs */

const en_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes`)
};

const de_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe`)
};

const fr_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums`)
};

const it_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum`)
};

const nl_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's`)
};

const pl_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelot`)
};

const da_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'er`)
};

const sv_pricing_compare_resumes = /** @type {(inputs: Pricing_Compare_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resumes" |
*
* @param {Pricing_Compare_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_resumes = /** @type {((inputs?: Pricing_Compare_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_resumes(inputs)
	if (locale === "fr") return fr_pricing_compare_resumes(inputs)
	if (locale === "es") return es_pricing_compare_resumes(inputs)
	if (locale === "it") return it_pricing_compare_resumes(inputs)
	if (locale === "nl") return nl_pricing_compare_resumes(inputs)
	if (locale === "pl") return pl_pricing_compare_resumes(inputs)
	if (locale === "fi") return fi_pricing_compare_resumes(inputs)
	if (locale === "da") return da_pricing_compare_resumes(inputs)
	if (locale === "sv") return sv_pricing_compare_resumes(inputs)
	return en_pricing_compare_resumes(inputs)
});